/* AVJ customer wishlist sync v1.7: Shop sign-in return auto-merge after customer login, compact records. Shopify Customer Account API public Web OAuth + PKCE.
   No Admin API credential, refresh token, or customer ID is accepted from the browser as proof of identity.
   Configure PUBLIC CLIENT ID in snippets/footer-js.liquid. */
(function () {
  'use strict';
  if (window.__avjCustomerWishlistLoaded) return;
  window.__avjCustomerWishlistLoaded = true;

  var cfg = window.AVJWishlistAccountConfig || {};
  var clientId = String(cfg.clientId || '');
  var enabled = clientId && clientId !== 'PASTE_PUBLIC_WEB_CLIENT_ID';
  var root = window.location.origin;
  var callbackUrl = root + '/pages/wishlist';
  var AUTH_KEY = 'avj-wishlist-oauth-pending-v1';
  var TOKEN_KEY = 'avj-wishlist-account-token-v1';
  // Track silent authorization per signed-in customer, not once forever per tab.
  // A recent Sign In click is useful when Liquid's customer object is delayed.
  var AUTO_KEY = 'avj-wishlist-auto-login-v2';
  var LOGIN_INTENT_KEY = 'avj-wishlist-login-intent-v1';
  var POST_LOGIN_ATTEMPT_KEY = 'avj-wishlist-post-login-attempt-v1';
  var AUTO_COOLDOWN_MS = 3 * 60000; // limit unauthenticated redirect bounce
  var LOGIN_INTENT_TTL_MS = 10 * 60000;
  var RETURN_QUERY = 'avj_wishlist_login';
  var PENDING_PREFIX = 'avj-wishlist-operations-';
  var auth = null;
  var ownerId = null;
  var endpoint = null;
  var connected = false;
  var sending = false;
  var connectInFlight = null;
  var retryTimer = null;
  var api = window.AVJWishlist;
  var statusEl;
  var actionEl;
  var GET_QUERY = 'query AVJCustomerWishlist { customer { id metafield(namespace:"custom",key:"wishlist") { value compareDigest } } }';
  var SET_MUTATION = 'mutation AVJSetWishlist($metafields:[MetafieldsSetInput!]!) { metafieldsSet(metafields:$metafields) { metafields { id compareDigest } userErrors { field message code } } }';

  function setStatus(message, isError) {
    if (!statusEl) statusEl = document.getElementById('avj-wishlist-sync-status');
    if (statusEl) {
      statusEl.textContent = message;
      statusEl.setAttribute('role', isError ? 'alert' : 'status');
    }
    // One primary action: start the Customer Account API login directly.
    // Normal Shopify header login and API authorization are separate sessions.
    if (actionEl) {
      actionEl.textContent = connected ? 'Sync now' : 'Sign in & sync wishlist';
      actionEl.setAttribute('aria-label', connected ? 'Refresh saved account wishlist' : 'Sign in with Shopify and sync wishlist');
    }
    if (isError) console.warn('[AVJ Customer Wishlist]', message);
  }
  function jsonGet(key) {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (ignore) { return null; }
  }
  function jsonSet(key, value) { sessionStorage.setItem(key, JSON.stringify(value)); }
  function hasGuestItems() {
    try { return !!(api && api.getGuestItems && api.getGuestItems().length); }
    catch (ignore) { return false; }
  }
  function httpsUrl(value) {
    var parsed = new URL(value, root);
    if (parsed.protocol !== 'https:') throw new Error('An HTTPS Shopify endpoint is required');
    return parsed.toString();
  }
  function bytesUrl(bytes) {
    var binary = '';
    bytes.forEach(function (byte) { binary += String.fromCharCode(byte); });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function randomUrl() {
    var bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);
    return bytesUrl(bytes);
  }
  function pendingKey() { return PENDING_PREFIX + (ownerId || ''); }
  function operations() {
    var result = jsonGet(pendingKey());
    return Array.isArray(result) ? result : [];
  }
  function saveOps(ops) { jsonSet(pendingKey(), ops.slice(-500)); }
  function removeAuthorization() {
    auth = null;
    ownerId = null;
    connected = false;
    endpoint = null;
    sessionStorage.removeItem(TOKEN_KEY);
    if (api && api.inAccount()) api.exitAccount();
  }
  function clientConfigured() {
    if (enabled) return true;
    setStatus('Account sync needs a configured Shopify public Web client ID.', true);
    return false;
  }
  function shopCustomerMatches(apiCustomerId) {
    var liquidId = cfg.liquidCustomerId;
    // Liquid is only a *cross-account consistency guard*, never authentication.
    return !liquidId || String(apiCustomerId).split('/').pop() === String(liquidId);
  }
  async function discovery(path) {
    var response = await fetch(root + path, { credentials: 'omit', cache: 'no-store' });
    if (!response.ok) throw new Error('Shopify discovery failed (' + response.status + ')');
    return response.json();
  }
  async function authorize(prompt) {
    if (!clientConfigured()) return;
    if (!window.crypto || !crypto.subtle || !window.sessionStorage) {
      setStatus('Your browser cannot securely authorize account sync.', true);
      return;
    }
    try {
      setStatus('Connecting to Shopify customer account…');
      var config = await discovery('/.well-known/openid-configuration');
      var verifier = randomUrl();
      var digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
      var state = randomUrl();
      var nonce = randomUrl();
      jsonSet(AUTH_KEY, { verifier: verifier, state: state, nonce: nonce, started: Date.now() });
      var url = new URL(httpsUrl(config.authorization_endpoint));
      url.searchParams.set('client_id', clientId);
      url.searchParams.set('response_type', 'code');
      url.searchParams.set('redirect_uri', callbackUrl);
      url.searchParams.set('scope', 'openid email customer-account-api:full');
      url.searchParams.set('state', state);
      url.searchParams.set('nonce', nonce);
      url.searchParams.set('code_challenge', bytesUrl(new Uint8Array(digest)));
      url.searchParams.set('code_challenge_method', 'S256');
      if (prompt) url.searchParams.set('prompt', prompt);
      window.location.assign(url.toString());
    } catch (error) { setStatus('Could not start Shopify authorization: ' + error.message, true); }
  }
  function clearCallbackQuery() {
    var current = new URL(window.location.href);
    ['code', 'state', 'error', 'error_description', 'iss'].forEach(function (param) {
      current.searchParams.delete(param);
    });
    history.replaceState(history.state, '', current.pathname + current.search + current.hash);
  }
  async function receiveCallback() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has('code') && !url.searchParams.has('error')) return false;
    var code = url.searchParams.get('code');
    var state = url.searchParams.get('state');
    var error = url.searchParams.get('error');
    clearCallbackQuery(); // Never leave a one-time code in the address bar.
    var previous = jsonGet(AUTH_KEY);
    // Remember whether the buyer deliberately started login. A guest's
    // background prompt=none check must never open an interactive login.
    var initiatedLogin = recentlyStartedLogin();
    sessionStorage.removeItem(AUTH_KEY);
    sessionStorage.removeItem(LOGIN_INTENT_KEY);
    sessionStorage.removeItem(POST_LOGIN_ATTEMPT_KEY);
    if (error) {
      if (error === 'login_required' && initiatedLogin && clientConfigured()) {
        // Shopify Online Store login and Customer Account API authorization
        // can be distinct. One interactive authorization finishes the merge.
        setStatus('Finishing Shopify account authorization…');
        await authorize();
      } else if (error !== 'login_required') {
        setStatus('Shopify sign-in did not complete: ' + error, true);
      } else {
        setStatus('Account wishlist not connected yet. Select Sign in & sync wishlist.');
      }
      return true;
    }
    if (!previous || !code || previous.state !== state || Date.now() - previous.started > 600000) {
      setStatus('Authorization state expired or did not match. Please try again.', true);
      return true;
    }
    if (!clientConfigured()) return true;
    try {
      var conf = await discovery('/.well-known/openid-configuration');
      var values = new URLSearchParams();
      values.set('grant_type', 'authorization_code');
      values.set('client_id', clientId);
      values.set('redirect_uri', callbackUrl);
      values.set('code', code);
      values.set('code_verifier', previous.verifier);
      var response = await fetch(httpsUrl(conf.token_endpoint), {
        method: 'POST', credentials: 'omit',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: values.toString()
      });
      if (!response.ok) throw new Error('Token request failed (' + response.status + ')');
      var token = await response.json();
      if (!token.access_token || !(Number(token.expires_in) > 0)) throw new Error('Missing access token');
      // A decoded ID token is NOT trusted as proof of identity; Shopify GraphQL is authoritative.
      // Validate nonce claim only as an extra OAuth replay check.
      if (token.id_token) {
        var segment = token.id_token.split('.')[1];
        var decoded = JSON.parse(atob(segment.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - segment.length % 4) % 4)));
        if (decoded.nonce !== previous.nonce) throw new Error('OIDC nonce mismatch');
      }
      auth = { token: token.access_token, expires: Date.now() + Number(token.expires_in) * 1000 };
      jsonSet(TOKEN_KEY, auth); // Short-lived access token only; no refresh token stored.
      await connect();
    } catch (cause) {
      removeAuthorization();
      setStatus('Account authorization failed: ' + cause.message, true);
    }
    return true;
  }
  async function graphql(query, variables) {
    if (!auth || auth.expires < Date.now() + 30000) throw new Error('Account authorization expired. Sync again.');
    if (!endpoint) {
      var config = await discovery('/.well-known/customer-account-api');
      endpoint = httpsUrl(config.graphql_api);
    }
    var res = await fetch(endpoint, {
      method: 'POST', credentials: 'omit',
      headers: { 'Content-Type': 'application/json', Authorization: auth.token },
      body: JSON.stringify({ query: query, variables: variables || {} })
    });
    if (res.status === 401 || res.status === 403) throw new Error('Shopify denied customer API access. Verify customer scopes and permissions.');
    if (!res.ok) throw new Error('Customer API HTTP ' + res.status);
    var payload = await res.json();
    if (payload.errors && payload.errors.length) throw new Error(payload.errors.map(function (e) { return e.message; }).join('; '));
    return payload.data;
  }
  function parseMetafield(value) {
    if (!value) return [];
    try {
      var parsed = JSON.parse(value);
      return Array.isArray(parsed.items) ? parsed.items : Array.isArray(parsed) ? parsed : [];
    } catch (error) { throw new Error('Customer wishlist JSON is invalid; no data was overwritten'); }
  }
  function itemKey(item) { return item.variant_id ? 'v:' + item.variant_id : 'h:' + item.product_handle; }
  function compact(item) {
    if (!item || typeof item !== 'object') return null;
    var handle = String(item.product_handle || item.handle || '').trim();
    var variant = item.variant_id == null ? '' : String(item.variant_id);
    if (!/^[a-zA-Z0-9][a-zA-Z0-9-]*$/.test(handle) || (variant && !/^\d+$/.test(variant))) return null;
    var when = Date.parse(item.added_at || '');
    return {
      product_handle: handle,
      variant_id: variant || null,
      added_at: Number.isFinite(when) ? new Date(when).toISOString() : '1970-01-01T00:00:00.000Z'
    };
  }
  function unique(items) {
    var seen = new Set();
    return (Array.isArray(items) ? items : []).map(compact).filter(Boolean)
      .sort(function (a, b) { return Date.parse(b.added_at) - Date.parse(a.added_at); })
      .filter(function (item) {
        var k = itemKey(item);
        if (seen.has(k)) return false;
        seen.add(k);
        return true;
      }).slice(0, 200);
  }
  function requiresMigration(rawValue, items) {
    if (!rawValue) return false;
    // Rewriting a legacy value once removes redundant properties and orders newest first.
    // compareDigest protects concurrent edits by another device.
    var parsed = JSON.parse(rawValue);
    return JSON.stringify(parsed) !== JSON.stringify({ version: 1, items: unique(items) });
  }
  function applyOps(items, ops) {
    var result = items.slice();
    ops.forEach(function (op) {
      if (!op || !op.item) return;
      if (op.type === 'add') {
        result = result.filter(function (existing) { return itemKey(existing) !== itemKey(op.item); });
        result.push(op.item);
      } else if (op.type === 'remove') {
        result = result.filter(function (existing) {
          // A legacy product-only entry should remove only that old entry.
          return itemKey(existing) !== itemKey(op.item);
        });
      }
    });
    return unique(result);
  }
  async function hydrateLegacy(items) {
    var fallback = items.filter(function (item) { return !item.variant_id; });
    if (!fallback.length) return items;
    var updates = await Promise.all(fallback.map(async function (item) {
      try {
        var r = await fetch('/products/' + encodeURIComponent(item.product_handle) + '.js');
        if (!r.ok) return item;
        var product = await r.json();
        var variant = (product.variants || []).find(function (v) { return v.available; }) || product.variants[0];
        if (!variant) return item;
        return compact({
          product_handle: item.product_handle,
          variant_id: String(variant.id),
          added_at: item.added_at
        });
      } catch (ignore) { return item; }
    }));
    var i = 0;
    return items.map(function (item) { return item.variant_id ? item : updates[i++]; });
  }
  async function readRemote() {
    var data = await graphql(GET_QUERY);
    if (!data || !data.customer || !data.customer.id) throw new Error('Shopify did not return an authenticated customer');
    var id = data.customer.id;
    if (!shopCustomerMatches(id)) {
      removeAuthorization();
      throw new Error('Storefront account changed. Re-authorize the current customer.');
    }
    var raw = data.customer.metafield && data.customer.metafield.value;
    var stored = parseMetafield(raw);
    return {
      ownerId: id,
      items: stored,
      needsMigration: requiresMigration(raw, stored),
      digest: data.customer.metafield ? data.customer.metafield.compareDigest : null
    };
  }
  // Call Shopify's Customer Account GraphQL API on page load and after
  // a restored page. Share simultaneous requests so a callback and pageshow
  // cannot overwrite the same wishlist in parallel.
  async function connectOnce() {
    setStatus('Loading your saved Shopify wishlist…');
    var remote = await readRemote(); // Authenticated GET, never a Liquid/customer-ID lookup.
    ownerId = remote.ownerId;
    connected = true;
    var guest = api.getGuestItems();
    var pending = operations();
    var combined = applyOps(unique(remote.items.concat(await hydrateLegacy(guest))), pending);
    api.setAccountItems(combined, String(ownerId).split('/').pop());
    setStatus('Wishlist loaded from your Shopify account.');
    // Avoid needless writes on ordinary page loads; only merge/migrate if needed.
    if (guest.length || pending.length || remote.needsMigration) await sendChanges(remote.needsMigration);
  }
  function connect() {
    if (connectInFlight) return connectInFlight;
    connectInFlight = connectOnce().finally(function () { connectInFlight = null; });
    return connectInFlight;
  }
  async function sendChanges(forceMigration) {
    if (sending || !connected || !ownerId) return;
    sending = true;
    try {
      var attempt = 0;
      while (attempt++ < 3) {
        var guest = api.getGuestItems();
        var pending = operations();
        if (!guest.length && !pending.length && forceMigration !== true) {
          setStatus('Wishlist synced with your account.');
          break;
        }
        var remote = await readRemote();
        if (remote.ownerId !== ownerId) throw new Error('Authenticated customer changed while saving');
        var merged = applyOps(unique(remote.items.concat(await hydrateLegacy(guest))), pending);
        var json = JSON.stringify({ version: 1, items: unique(merged) });
        var result = await graphql(SET_MUTATION, {
          metafields: [{
            ownerId: ownerId, namespace: 'custom', key: 'wishlist', type: 'json',
            value: json, compareDigest: remote.digest
          }]
        });
        var errors = result && result.metafieldsSet && result.metafieldsSet.userErrors || [];
        if (errors.length) {
          if (errors.some(function (e) { return /compare|stale|digest/i.test((e.code || '') + ' ' + e.message); })) continue;
          throw new Error(errors.map(function (e) { return e.message; }).join('; '));
        }
        if (!result || !result.metafieldsSet || !result.metafieldsSet.metafields ||
            !result.metafieldsSet.metafields.length) throw new Error('Metafield save returned no confirmation');
        // Clear only the operations included in this specific successful write.
        if (pending.length) saveOps(operations().slice(pending.length));
        forceMigration = false;
        if (guest.length) api.clearGuest();
        var freshOps = operations();
        api.setAccountItems(applyOps(merged, freshOps), String(ownerId).split('/').pop());
        if (!freshOps.length && !api.getGuestItems().length) setStatus('Wishlist saved to your Shopify account.');
        else continue;
        break;
      }
      if (attempt > 3 && (operations().length || api.getGuestItems().length)) {
        throw new Error('Concurrent updates detected. Try Sync now.');
      }
    } catch (error) {
      setStatus('Wishlist not yet synced: ' + error.message, true);
    } finally { sending = false; }
  }
  // Remember an account sign-in started from any Corona page, so returning
  // to the wishlist can trigger an SSO check even if Liquid is briefly empty.
  function noteSignInClick(event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || cfg.liquidCustomerId) return;
    var url;
    try { url = new URL(link.href, root); } catch (ignore) { return; }
    var path = url.pathname;
    var isLogin = /^\/customer_authentication\/login(?:\/|$)/i.test(path) ||
      /^\/account\/login(?:\/|$)/i.test(path) ||
      (/\.shopify\.com$/i.test(url.hostname) && /\/(?:authentication|login|sign-in)/i.test(path));
    if (isLogin) {
      sessionStorage.setItem(LOGIN_INTENT_KEY, String(Date.now()));
      sessionStorage.removeItem(AUTO_KEY); // A new sign-in may be the same customer again.
      removeAuthorization(); // Do not silently reuse an older customer's bearer token.
      // If guest items exist, route Login through Customer Account API OAuth
      // from any Corona page. That ensures an authenticated callback and merge
      // immediately after email/Shop login, without needing Sync Now.
      // Without guest items, other pages keep their standard login navigation.
      if ((statusEl || hasGuestItems()) && enabled && !connected && !event.defaultPrevented &&
          !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey &&
          (event.button === undefined || event.button === 0) &&
          (!link.target || link.target === '_self')) {
        event.preventDefault();
        authorize();
      }
    }
  }
  function captureLoginReturn() {
    var url = new URL(window.location.href);
    // Shopify's embedded Shop sign-in commonly returns to the storefront root
    // with ?shop_sign_in=true instead of following a custom return_to path.
    // Treat this as a ONE-TIME navigation hint, NEVER proof of identity.
    var fromWishlistLogin = url.searchParams.get(RETURN_QUERY) === '1';
    var fromShopLogin = url.searchParams.get('shop_sign_in') === 'true';
    if (!fromWishlistLogin && !fromShopLogin) return false;
    url.searchParams.delete(RETURN_QUERY);
    url.searchParams.delete('shop_sign_in');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    sessionStorage.setItem(LOGIN_INTENT_KEY, String(Date.now()));
    sessionStorage.removeItem(AUTO_KEY);
    sessionStorage.removeItem(POST_LOGIN_ATTEMPT_KEY);
    // Previous browser tokens may belong to another shopper. Force Shopify
    // Customer Account API to authenticate the CURRENT customer before read/write.
    removeAuthorization();
    return true;
  }
  function returnedFromAccountSignIn() {
    // Referrer is an optional *hint* for silent OAuth, not proof of login.
    try {
      var referrer = new URL(document.referrer);
      var host = referrer.hostname.toLowerCase();
      return /(^|\.)(shopify\.com|shop\.app|myshopify\.com)$/.test(host) &&
        /\/(?:account|authentication|login|auth|customer)/i.test(referrer.pathname);
    } catch (ignore) { return false; }
  }
  function recentlyStartedLogin() {
    var when = Number(sessionStorage.getItem(LOGIN_INTENT_KEY) || 0);
    if (!when || Date.now() - when >= LOGIN_INTENT_TTL_MS) {
      sessionStorage.removeItem(LOGIN_INTENT_KEY);
      return false;
    }
    return true;
  }
  async function autoConnectAfterLogin() {
    if (!statusEl || !enabled || connected) return;
    var customer = cfg.liquidCustomerId ? String(cfg.liquidCustomerId) : '';
    var fromLogin = recentlyStartedLogin() || returnedFromAccountSignIn();
    // Shopify's new account sessions sometimes do not immediately expose
    // the Liquid customer object. On the wishlist page, check once silently
    // even when neither Liquid nor the login link provides a signal.
    // This may produce a brief redirect for a guest, but never a login prompt.
    var context = customer ? 'customer:' + customer : (fromLogin ? 'login-return' : 'session-check');
    var prior = jsonGet(AUTO_KEY);
    var force = fromLogin;
    if (!force && prior && prior.context === context && Date.now() - prior.at < AUTO_COOLDOWN_MS) {
      setStatus('Account wishlist not connected yet. Select Sign in & sync wishlist.');
      return;
    }
    jsonSet(AUTO_KEY, { context: context, at: Date.now() });
    await authorize('none');
  }
  function onWishlistChanged(event) {
    if (!connected || !ownerId || !event.detail || event.detail.source !== 'account') return;
    if (!event.detail.operation) return;
    var pending = operations();
    pending.push(event.detail.operation);
    try { saveOps(pending); }
    catch (error) { setStatus('Could not queue wishlist change in this browser.', true); return; }
    clearTimeout(retryTimer);
    retryTimer = setTimeout(sendChanges, 350);
  }
  async function initialize() {
    statusEl = document.getElementById('avj-wishlist-sync-status');
    actionEl = document.getElementById('avj-wishlist-sync');
    if (actionEl) actionEl.addEventListener('click', function () {
      if (connected) connect().catch(function (error) {
        setStatus('Could not refresh account wishlist: ' + error.message, true);
      });
      else authorize(); // User-initiated interactive OAuth: login returns to this wishlist page.
    });
    window.addEventListener('avj:wishlist-changed', onWishlistChanged);
    window.addEventListener('pageshow', function (event) {
      // Revalidate the customer session after returning from another page/tab.
      // A BFCache document contains stale Liquid and stale rendered cards.
      if (!event.persisted) return;
      if (recentlyStartedLogin() || cfg.liquidCustomerId) {
        window.location.reload();
        return;
      }
      // No storefront identity signal: don't reuse an older customer token.
      removeAuthorization();
      if (statusEl) autoConnectAfterLogin();
    });
    window.addEventListener('online', function () {
      // If the first sync failed while offline, retry for the same authorized
      // customer only. No interactive login/redirect from this event.
      if (connected && auth && auth.expires > Date.now() + 30000) {
        connect().catch(function (error) {
          setStatus('Could not refresh account wishlist: ' + error.message, true);
        });
      }
    });
    document.addEventListener('click', noteSignInClick, true);
    document.addEventListener('click', function (event) {
      var a = event.target.closest && event.target.closest('a[href]');
      if (a && /\/account\/logout|\/account\/signout|\/account\/log_out/i.test(a.getAttribute('href'))) {
        removeAuthorization();
        sessionStorage.removeItem(AUTO_KEY);
        sessionStorage.removeItem(LOGIN_INTENT_KEY);
      }
    });
    if (!enabled) { setStatus('Account sync is not yet configured. Guest wishlist remains available.'); return; }
    var cameBackFromLogin = captureLoginReturn();
    if (await receiveCallback()) return;
    // The embedded Shop sign-in returns to /?shop_sign_in=true. Previously
    // this page had no wishlist controls and did nothing. Always start ONE
    // silent authorization check here, even without locally saved guest items.
    // The OAuth callback is still /pages/wishlist, where connect() loads the
    // customer metafield, merges guest items and writes only if changed.
    if (cameBackFromLogin) {
      var loginAttemptTime = sessionStorage.getItem(LOGIN_INTENT_KEY);
      jsonSet(POST_LOGIN_ATTEMPT_KEY, { intentTime: loginAttemptTime, at: Date.now(), source: 'login-return' });
      await authorize('none');
      return;
    }
    // Fallback for a normal login link that wasn't intercepted (for example,
    // opened in a new tab). The intent is captured before leaving Shopify's
    // Online Store, then a single prompt=none attempt runs upon return.
    // If SSO isn't reusable, receiveCallback offers one interactive flow.
    if (!statusEl && recentlyStartedLogin() && hasGuestItems()) {
      var intentTime = sessionStorage.getItem(LOGIN_INTENT_KEY);
      var attempted = jsonGet(POST_LOGIN_ATTEMPT_KEY);
      if (!attempted || attempted.intentTime !== intentTime) {
        jsonSet(POST_LOGIN_ATTEMPT_KEY, { intentTime: intentTime, at: Date.now() });
        await authorize('none');
      }
      return;
    }
    var saved = jsonGet(TOKEN_KEY);
    // Do not reuse an old customer token in a guest storefront session.
    // If Liquid has not exposed the newly signed-in customer yet, a recent
    // Sign In click will trigger a fresh prompt=none OAuth check instead.
    if (saved && !cfg.liquidCustomerId) {
      // No Liquid customer does NOT prove logout with new customer accounts.
      // However, reusing the old token could expose another shopper's wishlist.
      // Discard it and silently re-authorize the CURRENT Shopify SSO session.
      removeAuthorization();
      saved = null;
      if (statusEl) {
        sessionStorage.removeItem(AUTO_KEY);
        await authorize('none');
        return;
      }
    }
    if (saved && saved.token && saved.expires > Date.now() + 30000) {
      auth = saved;
      try { await connect(); return; }
      catch (error) {
        removeAuthorization();
        setStatus('Account sync needs fresh authorization: ' + error.message, true);
      }
    }
    // On the wishlist page, if no valid Customer Account API token exists,
    // obtain it with Shopify prompt=none. Ordinary storefront login alone
    // is not a token, and this navigation must not happen on catalog pages.
    await autoConnectAfterLogin();
  }
  window.AVJCustomerWishlist = {
    version: '1.7',
    authorize: authorize,
    sync: function () { return connected ? connect() : authorize(); },
    connected: function () { return connected; },
    disconnect: removeAuthorization
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();